import React from "react";
import MyPersonalStory from "../components/MyPersonalStory";
import SubHeadingBanner from "../components/organisms/SubHeadingBanner";
import useScrollToTop from "../hooks/useScrollToTop";
import Carosel from "../components/Carosel";
import bgAbout from '../assets/images/about1.avif';

function About() {
  useScrollToTop();
  return (
    <div>
      <SubHeadingBanner
        imageSrc={bgAbout}
        head1="Home - About"
        head2="About"
      />
      <MyPersonalStory />
      <Carosel />
    </div>
  );
}

export default About;
